import React from 'react';
import styled from '@emotion/styled';
import Title from '../../../../common/text/Title';
import OtherBankListContents from './OtherBankListContents';
import OtherBankConditionTable from '../table/OtherBankConditionTable';

const Base = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 8px;
  max-height: 85vh;
  overflow-y: overlay;

  & > h1 {
    grid-column: span 2;
  }

  & > table:first-of-type {
    align-self: end;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    width: 90vw;
    max-height: 75vh;
  }
`;

interface Props {
  closeEvent: () => void;
}

/**
 *  타금융사 할부비교 컨텐츠 컴포넌트
 * @param {function} closeEvent 모달 닫기 이벤트 함수
 *  */
function OtherBankContents({ closeEvent }: Props): JSX.Element {
  return (
    <>
      <Title text='타금융사 할부비교' />
      <Base>
        <OtherBankConditionTable />
        <OtherBankListContents closeEvent={closeEvent} />
      </Base>
    </>
  );
}

export default React.memo(OtherBankContents);
